import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import useHasRight from "../../authorization/hooks/useHasRight";

export default function useDiscussionChannelDropdownMenuOptions({
	channel,
	setOpenEditChannelModal,
	setOpenRemoveChannelModal,
	productionId,
}) {
	const { t } = useTranslation();

	const navigate = useNavigate();
	const hasRight = useHasRight();

	return [
		{
			key: "toProduction",
			value: "toProduction",
			text: t("toProduction", "To production"),
			onClick: () => navigate(`production/${productionId}`),
		},
		// {
		// 	key: "leave",
		// 	value: "leave",
		// 	text: t("leaveDiscussion", "Leave discussion"),
		// 	confirmText: t("confirmLeaveDiscussion", "Are you sure you want to leave this discussion channel?"),
		// 	hidden: !channel.userIds.includes(user.id) || channel.id.includes(user.id),
		// 	action: async () => {
		// 		await leaveDiscussionChannel(firebase, { channel, user });
		//
		// 		setDiscussion({ isOpen: true, channelId: null });
		// 	},
		// },
		{
			key: "edit",
			value: "edit",
			text: t("edit", "Edit"),
			onClick: () => setOpenEditChannelModal(true),
			hidden: channel?.name === "team" || channel?.name === "publisher" || !hasRight("discussions.manage"),
		},
		{
			key: "delete",
			value: "delete",
			text: t("remove", "Remove"),
			onClick: () => setOpenRemoveChannelModal(true),
			hidden: channel?.name === "team" || channel?.name === "publisher" || !hasRight("discussions.manage"),
		},
	];
}
